import { render, staticRenderFns } from "./WelcomeFourthScreen.vue?vue&type=template&id=1e835e20&"
import script from "./WelcomeFourthScreen.vue?vue&type=script&lang=js&"
export * from "./WelcomeFourthScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports